import AdvancedSearchBase, { type AdvancedSearchBaseProps } from '../lib/AdvancedSearchBase';

class BinderAdvancedSearch extends AdvancedSearchBase {
    constructor(props: AdvancedSearchBaseProps) {
        super(props);
        this.type = 'binder';
        this.title = 'Binder';
        this.state.values.title = '';
        this.state.values.keyword = '';
        this.state.values.description = '';
        this.state.values.doi = '';
    }

    getRows() {
        const rows = [
            { label: '[en]Title[/en][ja]タイトル[/ja]', value: this.renderFieldInputText('title', 50) },
            {
                label: '[en]Free Keywords[/en][ja]フリーキーワード[/ja]',
                value: this.renderFieldInputText('keyword', 50),
            },
            {
                label: '[en]Description[/en][ja]概要[/ja]',
                value: this.renderFieldInputText('description', 50),
            },
            { label: 'ID', value: this.renderFieldInputText('doi', 50) },
        ];
        return rows;
    }
}

export default BinderAdvancedSearch;
